module.exports = __webpack_public_path__ + "static/img/IMG_20150611_143531.d617903a.jpg";